import React, {Component} from 'react'

class TableHead extends Component {
    render() {
        return (
            <thead className="TableHead">
                <tr>
                    <th className="barcode">Barcode</th>
                    <th className="sku">SKU</th>
                    <th className="type-error">Loại Lỗi</th>
                    <th className="detail-error">Chi tiết lỗi</th>
                    <th className="user-printed">Người in</th>
                    <th className="date-mark">Ngày đánh dấu</th>
                    <th className="user-mark">Người đánh dấu</th>
                </tr>
            </thead>
        )
    }
}

export default TableHead